<!-- PAGO PRIMAS PERIODICAS - CASO NORMAL -->
<div
  class="primas"
  [ngClass]="showTotalResumen ? 'border' : 'border-none'"
  *ngIf="(showPeriodicas || showEsporadicas) && !showMode"
>
  <div *ngIf="showPeriodicas && !showAporteCUI && !isAPVSelectDirect">
    <span class="title">
      PRIMAS PERIÓDICAS
      <svg-icon
        class="icon"
        app-tooltip="Pago regular que hace el contratante por el monto y periodicidad comprometida en la póliza."
        position="right"
        src="../../../../../assets/icons/information-right.svg"
        [svgStyle]="{
          'width.rem': 0.93,
          'height.rem': 0.87,
          position: 'relative',
          'left.rem': 0.15
        }"
      ></svg-icon>
    </span>
    <app-empty-data-message
      *ngIf="!data || data?.length === 0"
      [message]="'No existen pagos pendientes.'"
    >
    </app-empty-data-message>
    <div *ngIf="data && data.length > 0">
      <span class="subtitle">
        Selecciona los períodos pendientes a pagar:
      </span>
      <app-table
        *ngIf="
          !error &&
          displayedColumns &&
          displayedColumns.length > 0 &&
          data &&
          data.length > 0
        "
        [theme]="1"
        [displayedColumns]="displayedColumns"
        [datasource]="data"
      ></app-table>
      <app-paginator-custom
        [pageSize]="pageSize"
        *ngIf="data?.length > 0"
        [pageSizeOptions]="pageSizeOptions"
        [length]="paginatorLength"
        ($onChangePage)="getDataPaginator($event)"
      ></app-paginator-custom>
    </div>
  </div>
  <div
    style="margin-bottom: 0.25rem; margin-top: 0.9375rem;"
    *ngIf="showEsporadicas"
  >
    <app-aportes-input-cui
      *ngIf="showAporteCUI"
      [showMessageCuiNoApv]="showMessageCuiNoApv"
      [pagoStyle]="pagoStyle"
      [showImpagosPFEspecial]="data?.length > 2"
      [showMessageDecember]="showMessageDecember"
      [showMessageCuiApvRegimen]="showMessageCuiApvRegimen"
      [resumen]="resumen"
      ($onClickAporte)="onRealizarAporte($event)"
    >
    </app-aportes-input-cui>
  </div>
</div>
<!-- PAGA TU PRIMA PERIODICA - CASO PF - SELECCION DE AVISO DE COBRANZA -->
<div
  class="primas"
  [ngClass]="showTotalResumen ? 'border' : 'border-none'"
  *ngIf="(showPeriodicas || showEsporadicas) && showMode"
>
  <div *ngIf="showPeriodicas">
    <span class="title">
      PAGA TU PRIMA PERIÓDICA
      <svg-icon
        class="icon"
        app-tooltip="Pago regular que hace el contratante por el monto y periodicidad comprometida en la póliza."
        position="right"
        src="../../../../../assets/icons/information-right.svg"
        [svgStyle]="{
          'width.rem': 0.93,
          'height.rem': 0.87,
          position: 'relative',
          'left.rem': 0.15
        }"
      ></svg-icon>
    </span>
    <app-empty-data-message
      *ngIf="!data || data?.length === 0"
      [message]="'No existen pagos pendientes.'"
    >
    </app-empty-data-message>
    <!--radio button-->
    <div *ngIf="data && data.length > 0">
      <span class="subtitle app-endoso">
        Selecciona como deseas pagar:
      </span>
      <!--radio button, opcion 1 datatable, opcion 2 descarga avisos cobranza-->
      <div class="row type-rescue-select py-2 app-endoso">
        <mat-radio-group
          labelPosition="after"
          class="radio-group-container"
          id="tipoPago"
          [(ngModel)]="pagoSeleccionado"
        >
          <mat-radio-button
            class="radio-button-ib"
            [color]="'primary'"
            *ngFor="let pago of pagos"
            [value]="pago"
            (change)="onChangeMode($event)"
          >
            {{ pago }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <!--Pagar online [0]-->
    <div *ngIf="pagoSeleccionado === pagos[0]">
      <div *ngIf="data && data.length > 0">
        <app-table
          *ngIf="
            !error &&
            displayedColumns &&
            displayedColumns.length > 0 &&
            data &&
            data.length > 0
          "
          [theme]="1"
          [displayedColumns]="displayedColumns"
          [datasource]="data"
        ></app-table>
        <app-paginator-custom
          [pageSize]="pageSize"
          *ngIf="data?.length > 0"
          [pageSizeOptions]="pageSizeOptions"
          [length]="paginatorLength"
          ($onChangePage)="getDataPaginator($event)"
        ></app-paginator-custom>
      </div>
      <div
        style="margin-bottom: 0.25rem; margin-top: 0.9375rem;"
        *ngIf="showEsporadicas"
      >
        <mat-divider
          *ngIf="showAporteCUI"
          style="margin-bottom: 0.5rem"
        ></mat-divider>
        <app-aportes-input-cui
          *ngIf="showAporteCUI"
          [showMessageCuiNoApv]="showMessageCuiNoApv"
          [pagoStyle]="pagoStyle"
          [showImpagosPFEspecial]="data?.length > 2"
          [showMessageDecember]="showMessageDecember"
          [showMessageCuiApvRegimen]="showMessageCuiApvRegimen"
          [resumen]="resumen"
          ($onClickAporte)="onRealizarAporte($event)"
        >
        </app-aportes-input-cui>
      </div>

      <div class="container-message" *ngIf="showMessageCuiNoApv">
        <mat-icon>info_outline</mat-icon>

        <ul>
          <li>
            A estos pagos se les aplicará la distribución vigente de
            Alternativas de Rentabilidad.
          </li>
          <li>
            Esta prima será abonada a tu póliza dentro de 3 días hábiles.
          </li>
        </ul>
      </div>
      <!-- Regimen -->
      <div *ngIf="showMessageCuiApvRegimen">
        <div *ngIf="showRegimen('A')" class="container-message">
          <mat-icon>info_outline</mat-icon>

          <div>
            <b style="padding-left: 0.75rem">Régimen A</b>
            <ul>
              <li>
                El beneficio tributario de los DAPV equivale a una Bonificación
                Fiscal del 15% de lo ahorrado en el año con un tope de 6 UTM
              </li>
              <li>
                Estos aportes se acogerán al régimen tributario vigente en tu
                póliza.
              </li>
              <li>
                A estos pagos se les aplicará la distribución de Alternativas de
                Rentabilidad vigente.
              </li>
              <li>
                Esta prima será abonada a tu póliza dentro de 3 días hábiles.
              </li>
            </ul>
          </div>
        </div>

        <div *ngIf="showRegimen('B')" class="container-message regimen-b">
          <mat-icon>info_outline</mat-icon>

          <ul>
            <li>
              Para obtener el beneficio tributario asociado a estos aportes,
              deberás realizar tu declaración de impuesto anual Global
              Complementario.
            </li>
            <li>
              En <b>Régimen B</b>, el tope anual para beneficios tributarios en
              los DAPV es de UF 600 entre todos sus APV.
            </li>
            <li>
              Estos aportes se acogerán al régimen tributario vigente en su
              póliza.
            </li>
            <li>
              A estos pagos se les aplicará la distribución vigente de
              Alternativas de Rentabilidad.
            </li>
            <li>
              Esta prima será abonada a tu póliza dentro de 3 días hábiles.
            </li>
          </ul>
        </div>
      </div>

      <div
        class="container-message-warning"
        *ngIf="data.length === 2 && showMessageNoCuiPF"
      >
        <svg-icon
          src="../../../assets/icons/exclamation-message-warning.svg"
          [svgStyle]="{
            'width.rem': 1.5,
            'height.rem': 1.5,
            position: 'relative',
            'top.rem': 0.15
          }"
        ></svg-icon>
        <ul>
          <li>
            Su póliza caducará con tres periodos impagos.
          </li>
        </ul>
      </div>

      <div
        class="container-message-error"
        *ngIf="data?.length > 2 && showMessageNoCuiPF"
      >
        <svg-icon
          src="../../../assets/icons/exclamation-message-error.svg"
          [svgStyle]="{
            'width.rem': 1.5,
            'height.rem': 1.5,
            position: 'relative',
            'top.rem': 0.15
          }"
        ></svg-icon>
        <ul>
          <li>
            En caso de no recibir pago de prima, tu póliza caducará en los
            próximos días.
          </li>
        </ul>
      </div>

      <div class="container-message-warning" *ngIf="showMessageDecember">
        <svg-icon
          src="../../../assets/icons/exclamation-message-warning.svg"
          [svgStyle]="{
            'width.rem': 1.5,
            'height.rem': 1.5,
            position: 'relative',
            'top.rem': 0.15
          }"
        ></svg-icon>
        <ul>
          <li>
            Recuerda que todos los pagos recibidos hasta las 14 hrs del 31 de
            diciembre {{ dateAnnio() }} se consideran parte del año tributario
            {{ dateAnnio() }}
          </li>
        </ul>
      </div>

      <div class="container-message" *ngIf="showMessageNoCuiPF">
        <mat-icon>info_outline</mat-icon>

        <ul>
          <li *ngIf="data?.length > 2">
            Con tus primas al día, evitas riesgos de anulación de la póliza y
            mantienes vigente la protección del seguro.
          </li>
          <li>
            Esta prima será abonada a tu póliza dentro de 3 días hábiles.
          </li>
        </ul>
      </div>
    </div>
    <!--Pagar en Banco con aviso de cobranza [1]-->
    <div *ngIf="pagoSeleccionado === pagos[1]">
      <span class="subtitle app-endoso">
        <br />
        Descarga el aviso de cobranza para pagar en los bancos en convenio:<br />
        Banco de Chile (solo para cuentacorrentistas), Servipag y Banco Estado.
      </span>
      <div *ngIf="data && data.length > 0">
        <app-table
          *ngIf="
            !error &&
            displayedColumnsACobranza &&
            displayedColumnsACobranza.length > 0 &&
            data &&
            data.length > 0
          "
          [theme]="1"
          [displayedColumns]="displayedColumnsACobranza"
          [datasource]="data"
          (iconClick$)="onIconClick($event)"
        ></app-table>
        <app-paginator-custom
          [pageSize]="pageSize"
          *ngIf="data?.length > 0"
          [pageSizeOptions]="pageSizeOptions"
          [length]="paginatorLength"
          ($onChangePage)="getDataPaginator($event)"
        ></app-paginator-custom>
      </div>
      <div
        style="margin-bottom: 0.25rem; margin-top: 0.9375rem;"
        *ngIf="showEsporadicas"
      >
        <mat-divider
          *ngIf="showAporteCUI"
          style="margin-bottom: 0.5rem"
        ></mat-divider>
        <app-aportes-input-cui
          *ngIf="showAporteCUI"
          [showMessageCuiNoApv]="showMessageCuiNoApv"
          [pagoStyle]="pagoStyle"
          [showImpagosPFEspecial]="data?.length > 2"
          [showMessageDecember]="showMessageDecember"
          [showMessageCuiApvRegimen]="showMessageCuiApvRegimen"
          [resumen]="resumen"
          ($onClickAporte)="onRealizarAporte($event)"
        >
        </app-aportes-input-cui>
      </div>

      <div class="container-message" *ngIf="showMessageCuiNoApv">
        <mat-icon>info_outline</mat-icon>

        <ul>
          <li>
            A estos pagos se les aplicará la distribución vigente de
            Alternativas de Rentabilidad.
          </li>
          <li>
            Esta prima será abonada a tu póliza dentro de 3 días hábiles.
          </li>
        </ul>
      </div>
      <!-- Regimen -->
      <div *ngIf="showMessageCuiApvRegimen">
        <div *ngIf="showRegimen('A')" class="container-message">
          <mat-icon>info_outline</mat-icon>

          <div>
            <b style="padding-left: 0.75rem">Régimen A</b>
            <ul>
              <li>
                El beneficio tributario de los DAPV equivale a una Bonificación
                Fiscal del 15% de lo ahorrado en el año con un tope de 6 UTM
              </li>
              <li>
                Estos aportes se acogerán al régimen tributario vigente en tu
                póliza.
              </li>
              <li>
                A estos pagos se les aplicará la distribución de Alternativas de
                Rentabilidad vigente.
              </li>
              <li>
                Esta prima será abonada a tu póliza dentro de 3 días hábiles.
              </li>
            </ul>
          </div>
        </div>

        <div *ngIf="showRegimen('B')" class="container-message regimen-b">
          <mat-icon>info_outline</mat-icon>

          <ul>
            <li>
              Para obtener el beneficio tributario asociado a estos aportes,
              deberás realizar tu declaración de impuesto anual Global
              Complementario.
            </li>
            <li>
              En <b>Régimen B</b>, el tope anual para beneficios tributarios en
              los DAPV es de UF 600 entre todos sus APV.
            </li>
            <li>
              Estos aportes se acogerán al régimen tributario vigente en su
              póliza.
            </li>
            <li>
              A estos pagos se les aplicará la distribución vigente de
              Alternativas de Rentabilidad.
            </li>
            <li>
              Esta prima será abonada a tu póliza dentro de 3 días hábiles.
            </li>
          </ul>
        </div>
      </div>

      <div
        class="container-message-warning"
        *ngIf="data.length === 2 && showMessageNoCuiPF"
      >
        <svg-icon
          src="../../../assets/icons/exclamation-message-warning.svg"
          [svgStyle]="{
            'width.rem': 1.5,
            'height.rem': 1.5,
            position: 'relative',
            'top.rem': 0.15
          }"
        ></svg-icon>
        <ul>
          <li>
            Su póliza caducará con tres periodos impagos.
          </li>
        </ul>
      </div>

      <div
        class="container-message-error"
        *ngIf="data?.length > 2 && showMessageNoCuiPF"
      >
        <svg-icon
          src="../../../assets/icons/exclamation-message-error.svg"
          [svgStyle]="{
            'width.rem': 1.5,
            'height.rem': 1.5,
            position: 'relative',
            'top.rem': 0.15
          }"
        ></svg-icon>
        <ul>
          <li>
            En caso de no recibir pago de prima, tu póliza caducará en los
            próximos días.
          </li>
        </ul>
      </div>

      <div class="container-message-warning" *ngIf="showMessageDecember">
        <svg-icon
          src="../../../assets/icons/exclamation-message-warning.svg"
          [svgStyle]="{
            'width.rem': 1.5,
            'height.rem': 1.5,
            position: 'relative',
            'top.rem': 0.15
          }"
        ></svg-icon>
        <ul>
          <li>
            Recuerda que todos los pagos recibidos hasta las 14 hrs del 31 de
            diciembre {{ dateAnnio() }} se consideran parte del año tributario
            {{ dateAnnio() }}
          </li>
        </ul>
      </div>

      <div class="container-message" *ngIf="showMessageNoCuiPF">
        <mat-icon>info_outline</mat-icon>

        <ul>
          <li *ngIf="data?.length > 2">
            Con tus primas al día, evitas riesgos de anulación de la póliza y
            mantienes vigente la protección del seguro.
          </li>
          <li>
            Esta prima será abonada a tu póliza dentro de 3 días hábiles.
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
